export default __webpack_public_path__ + "static/media/chatmaison.e178964d.png";